export default "__VITE_ASSET__BzZc0RLz__"